import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordRoutingModule } from './forgot-password-routing.module';
import { ForgotPasswordComponent } from './forgot-password.component';
import { AuthService } from '../auth/auth.service';
import { LoadingModule } from 'ngx-loading';

@NgModule({
  imports: [
    CommonModule,
    ForgotPasswordRoutingModule,
    FormsModule,
    LoadingModule,
    ReactiveFormsModule
  ],
  declarations: [ForgotPasswordComponent],
  providers: [AuthService]
})
export class ForgotPasswordModule { }



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.module.ts